
import request from '@/utils/request';
// 获取费用
export const getPriceList = (params: any) =>
  request({
    url: 'Price/priceList',
    method: 'GET',
    params
  });
  // add
export const addPrice = (data: any) =>
  request({
    url: 'Price/price',
    method: 'POST',
    data
  });
export const editorPrice = (data: any) =>
  request({
    url: 'Price/price',
    method: 'PUT',
    data
  });
export const delPrice = (data: any) =>
  request({
    url: 'Price/price',
    method: 'DELETE',
    data
  });
  // Price/showOtherPrice
export const setOtherPriceSetting = (data: any) =>
  request({
    url: 'Price/otherPriceSet',
    method: 'PUT',
    data
  });
